// Player career stages (FC 25 pattern: visible development stage on
// every player card). Pure derivation from age — no state changes.

export type PlayerStage = 'rising' | 'peak' | 'veteran'

export interface StageDefinition {
  id: PlayerStage
  label: string
  /** CSS class suffix: .stage-rising / .stage-peak / .stage-veteran */
  className: string
}

export const STAGE_DEFINITIONS: Record<PlayerStage, StageDefinition> = {
  rising: { id: 'rising', label: 'Promesa', className: 'stage-rising' },
  peak: { id: 'peak', label: 'Pico', className: 'stage-peak' },
  veteran: { id: 'veteran', label: 'Veterano', className: 'stage-veteran' },
}

/**
 * Aligned with playersConfig youth factors (cuts at 22/28/32) and
 * RosterSystem decline age (33).
 */
export function getPlayerStage(age: number): PlayerStage {
  if (age < 23) return 'rising'
  if (age <= 30) return 'peak'
  return 'veteran'
}
